module.exports = __webpack_public_path__ + "static/media/groovy-ale.28269aed.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/information/beers/groovy-ale.jpg
// module id = 594
// module chunks = 0